export class UpdaterConfig {
  checkInterval: number;
}
